// eslint-disable-next-line @nx/enforce-module-boundaries
import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { InvoiceType, SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { InvoicesItemsPage } from "./InvoicesItemsPage/InvoicesItemsPage";
import { InvoicesItemFormPage } from "./InvoicesItemFormPage/InvoicesItemFormPage";
import { InvoicesBusinessInformationPage } from "./InvoicesSettingsPage/pages/InvoicesBusinessInformationPage";
import { InvoicesClientDefaultsPage } from "./InvoicesSettingsPage/pages/InvoicesClientDefaultsPage";

export type InvoicesPagesNavigationParams = {
  invoices: PageNavParams;
  invoicesItemForm: PageNavParams<{ type: InvoiceType }>;
  invoicesItemFormEdit: PageNavParams<{ id: string }>;
  invoicesSettingsBusinessInformation: PageNavParams;
  invoicesSettingsClientDefaults: PageNavParams;
};

export const invoicesPagesNavigationConfig: ModulePagesConfig<InvoicesPagesNavigationParams> =
  {
    invoices: {
      element: <InvoicesItemsPage />,
      path: "invoices",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.invoices,
      requiredModules: [SubscriptionPlanModuleId.invoices],
    },
    invoicesItemForm: {
      element: <InvoicesItemFormPage />,
      path: "/invoices/create/:type",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.invoices,
      requiredModules: [SubscriptionPlanModuleId.invoices],
    },
    invoicesItemFormEdit: {
      element: <InvoicesItemFormPage />,
      path: "/invoices/edit/:id",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.invoices,
      requiredModules: [SubscriptionPlanModuleId.invoices],
    },
    invoicesSettingsBusinessInformation: {
      element: <InvoicesBusinessInformationPage />,
      path: "/invoices/settings/business-information",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.invoices,
      requiredModules: [SubscriptionPlanModuleId.invoices],
    },
    invoicesSettingsClientDefaults: {
      element: <InvoicesClientDefaultsPage />,
      path: "/invoices/settings/client-defaults",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.invoices,
      requiredModules: [SubscriptionPlanModuleId.invoices],
    },
  };
